{
  "version": 1,
  "asset_id": "eac43fa2-d138-430e-9a26-dfb02e01537a",
  "project_id": "e1a64cc6-0fc8-4a5b-9036-8fa01cc3f811",
  "url": "/__l5e/assets-v1/eac43fa2-d138-430e-9a26-dfb02e01537a/clip-img_0120-poster-sm.webp",
  "r2_key": "a/v1/e1a64cc6-0fc8-4a5b-9036-8fa01cc3f811/eac43fa2-d138-430e-9a26-dfb02e01537a/clip-img_0120-poster-sm.webp",
  "original_filename": "clip-img_0120-poster-sm.webp",
  "size": 78536,
  "content_type": "image/webp",
  "created_at": "2026-08-15T18:08:06Z"
}
